// extracted by mini-css-extract-plugin
module.exports = {"BaseStatus":"BaseOrderBy_BaseStatus_2rQCb"};